module.exports = __webpack_public_path__ + "img/check_pass.bd10fbf6.svg";